import { useState } from "react";
import { X } from "lucide-react";
import { toast } from "react-toastify";

const ContactModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const trimmedData = {
      name: formData.name.trim(),
      email: formData.email.trim(),
      message: formData.message.trim(),
    };

    if (!trimmedData.name || !trimmedData.email || !trimmedData.message) {
      toast.error("Please fill in all required fields");
      return;
    }

    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbxH24ZcnUUb7T9cibs9IZtrGGpUl0yVrfK3rwCi4qgiYoYnMdWLxzOHPpYZ8KI-rNJ9/exec",
        {
          mode: "no-cors",
          method: "POST",
          body: JSON.stringify(trimmedData),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("Your message has been saved");
      onClose();
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error submitting the form");
    }
  };

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-6"
      onMouseDown={(e) => e.target === e.currentTarget && onClose()}
    >
      <div 
        className="bg-white rounded-lg shadow-xl max-w-sm w-full"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center p-5 border-b">
          <h2 className="text-lg font-semibold text-gray-800">Contact Us</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-5">
          <div className="mb-3">
            <label
              htmlFor="name"
              className="block text-sm font-bold text-gray-800 mb-1"
            >
              Your Name
            </label>
            <input
              type="text"
              name="name"
              id="name"
              required
              value={formData.name}
              onChange={handleInputChange}
              className="w-full text-sm rounded-md border border-gray-300 shadow-sm focus:border-[#243D86] focus:ring-1 focus:ring-[#243D86] p-2.5"
              placeholder="Type Full Name"
            />
          </div>

          <div className="mb-3">
            <label
              htmlFor="email"
              className="block text-sm font-bold text-gray-800 mb-1"
            >
              Your Email Address
            </label>
            <input
              type="email"
              name="email"
              id="email"
              required
              value={formData.email}
              onChange={handleInputChange}
              className="w-full text-sm rounded-md border border-gray-300 shadow-sm focus:border-[#243D86] focus:ring-1 focus:ring-[#243D86] p-2.5"
              placeholder="Type Email"
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="message"
              className="block text-sm font-bold text-gray-800 mb-1"
            >
              Your Message
            </label>
            <textarea
              id="message"
              name="message"
              rows={3}
              required
              value={formData.message}
              onChange={handleInputChange}
              className="w-full text-sm rounded-md border border-gray-300 shadow-sm focus:border-[#243D86] focus:ring-1 focus:ring-[#243D86] p-2.5"
              placeholder="Type Message"
            ></textarea>
          </div>

          <button
            type="submit"
            className="w-full inline-flex items-center justify-center rounded-full bg-[#243D86] py-2.5 px-6 text-sm font-medium text-white shadow-sm hover:bg-[#1a2d66] focus:outline-none focus:ring-2 focus:ring-[#243D86] focus:ring-offset-2 transition duration-300"
          >
            Send
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4 ml-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 12h16m-6-6l6 6-6 6"
              />
            </svg>
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactModal;
